import { ORG_ROLE_LABELS, type OrgMembershipRole } from "@/auth/membershipRoles";
import { useTheme } from "@/theme/ThemeProvider";
import { Card } from "@/ui/components/Card";
import { StatusChip } from "@/ui/components/StatusChip";
import { WorkTabs } from "@/ui/components/WorkTabs";
import type { ReactNode } from "react";
import { Text, View } from "react-native";

export type ClubSectionTab = "posts" | "members";

export function ClubSection({
  orgName,
  roles,
  showSuperadminChip,
  active,
  onSelect,
  headerAction,
  children,
}: {
  orgName: string;
  roles: readonly OrgMembershipRole[];
  showSuperadminChip: boolean;
  active: ClubSectionTab;
  onSelect: (tab: ClubSectionTab) => void;
  headerAction?: ReactNode;
  children: ReactNode;
}) {
  const { theme } = useTheme();
  const chips = showSuperadminChip
    ? ["Superadmin"]
    : roles.map((role) => ORG_ROLE_LABELS[role]);

  return (
    <View style={{ gap: theme.space.lg }}>
      <Card>
        <Text
          style={{
            color: theme.color.text,
            fontSize: theme.fontSize.h3,
            fontWeight: "800",
          }}
        >
          {orgName}
        </Text>
        <Text
          style={{
            color: theme.color.muted,
            fontSize: theme.fontSize.small,
            marginTop: theme.space.sm,
            marginBottom: theme.space.xs,
          }}
        >
          Deine Rollen:
        </Text>
        <View style={{ flexDirection: "row", flexWrap: "wrap", gap: theme.space.xs }}>
          {chips.length === 0 ? (
            <StatusChip label="Mitglied" tone="neutral" size="sm" />
          ) : (
            chips.map((label) => (
              <StatusChip key={label} label={label} tone="neutral" size="sm" />
            ))
          )}
        </View>
      </Card>
      {headerAction}
      <WorkTabs
        activeId={active}
        onSelect={(id) => onSelect(id === "members" ? "members" : "posts")}
        tabs={[
          {
            id: "posts",
            label: "Beiträge",
            panel: active === "posts" ? children : <View />,
          },
          {
            id: "members",
            label: "Mitglieder",
            panel: active === "members" ? children : <View />,
          },
        ]}
      />
    </View>
  );
}
